import { render, staticRenderFns } from "./LicenseCardMobile.vue?vue&type=template&id=9c440f6e&"
import script from "./LicenseCardMobile.vue?vue&type=script&lang=js&"
export * from "./LicenseCardMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports